<template>
    <div>
        <div class="pos kzgmain">
            <b> 您的位置：</b>
            <a href="/" title="首页"> 首页 </a>
            <!-- <i>
                <router-link :to="{ path: '/HzControl', query: { name: '系统控制柜' } }">系统控制柜
                </router-link>
            </i> -->
            <i>
                <span> &gt; </span>
                <router-link :to="{ path: '/HzControl', query: { id: id, name: name } }"> {{ this.name }}</router-link>
            </i>
        </div>
        <!-- 控制柜分类 -->
        <div class="pos_bor kzgmain">
            <div class="side">
                <div class="side_tit">
                    <h2>恒智自控<br>control cabinet</h2>
                </div>
                <div class="side_type">
                    <!--  -->
                    <div v-bind:class="name == item.name ? 'hov' : ''" v-for="(item, index) in cptypeList" :key="index">
                        <h3>
                            <router-link class="side_bor" :title="item.name"
                                :to="{ path: '/HzControl', query: item.superior == '0' ? { id: item.id, superior: item.superior, name: item.name } : { superior: item.superior, id: item.id, name: item.name } }">
                                {{ item.name }}
                            </router-link>
                        </h3>
                    </div>
                </div>
                <div class="side_tit" style="margin-top: 10px;">
                    <h2>
                        在线联系：<br>
                        <!-- <img src="../../images/phone12.png" style="width: 35px;height: 35px;"> -->
                        0531-83176606
                    </h2>
                </div>
            </div>
            <div class="tab">
                <h2 class="t_name"><span>{{ this.name }}</span></h2>
                <div class="tab_items">
                    <router-link class="tab_item"
                        :to="name == '系统控制柜' || item.treeId == '8' ? { path: '/HzDetails', query: { id: item.ciId, name: item.cmName,superior: item.treeId } }: { path: '/HzDetails', query: { id: item.ciId, name: name,superior: item.cmId } }"
                        v-for="(item, index) in infoList" :key="index">
                        <div class="tab_photo">
                            <div class="img_frame">
                                <span class="com_name">济南恒智自控</span>
                                <span class="cpt">{{ item.cpTitle }}</span>
                                <img :alt="item.ciTitle" :src="item.ciCoverPath" :title="item.ciTitle">
                            </div>
                        </div>
                        <div class="tab_detail">
                            <h2>
                                <span>{{ item.ciTitle }}</span>
                            </h2>
                            <p>{{ item.ciOverview }}</p>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from '../../js/axios'
import router from '../../router'

export default {
    name: 'HzControl',
    components: {
        router
    },
    data() {
        return {
            id: this.$route.query.id,
            name: this.$route.query.name,
            image: '',
            cptypeList: [],
            infoList: [],
        };
    },
    computed: {},
    watch: {
    },
    methods: {
        queryCpInfo() {
            let cmType = this.name;
            let cmId = this.id;
            if (this.name !== '系统控制柜') {
                cmType = '';
            } else {
                cmId = ''
            }
            http.get('/hzCpInfo/cpInfo', { params: { cmType: cmType, cmId: cmId } }).then((res) => {
                this.infoList = res.data.data.result;
                this.infoList.forEach(item => {
                    item.ciCoverPath = this.image + item.ciCoverPath;
                    item.cpTitle = item.ciTitle.split('控制柜')[0];
                    this.cptypeList.forEach(t => {
                        if(t.id === item.cmId){
                            item.cmName = t.name
                            item.treeId = t.superior
                        }
                    })
                })
                console.log(this.infoList);
            })
        }
    },
    created() {
        this.image = http.imageURL
        this.cptypeList = JSON.parse(window.localStorage.getItem('kzgType'));
        console.log(this.cptypeList);
        window.localStorage.setItem('titles', '恒智控制柜');
        this.queryCpInfo();
    },
    mounted() {

    }
}
</script>

<style>
@import "../../config/Control.css"
</style>


// WEBPACK FOOTER //
// src/views/controlCab/HzControl.vue